import {
  DatePipe,
  HashLocationStrategy,
  LocationStrategy,
} from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";

import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

// Import containers
const APP_CONTAINERS = [DefaultLayoutComponent];

import {
  AppSplashComponent,
  AppBreadcrumbsComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV,
} from "./containers/components";

const APP_COMPONENTS = [
  AppSplashComponent,
  AppBreadcrumbsComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV,
];

import { P404Component } from "./main/error/404.component";
import { P500Component } from "./main/error/500.component";
import { LoginComponent } from "./main/login/login.component";

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
} from "./directives";

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
];

// Import routing module
import { AppRoutingModule } from "./app.routing";

// Import 3rd party components
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { TabsModule } from "ngx-bootstrap/tabs";
import { HttpErrorHandler } from "./error/HttpErrorResponse";
import { ErrorInterceptor } from "./main/auth/error.interceptor";
import { JwtInterceptor } from "./main/auth/jwt.interceptor";
import { SharePipeModule } from "./main/pipes/share-pipe.module";
import { ResetPasswordComponent } from "./main/reset-password/reset-password.component";
import { CommonService } from "./main/services/common.service";
import { CompareDateValidatorDirective } from "./main/shared/compare-date.directive";
import { CompareReviewDateValidatorDirective } from "./main/shared/compare-reiview-date.directive";
import { IdentityRevealedValidatorDirective } from "./main/shared/identity-revealed.directive";
import { ChangePasswordComponent } from "./main/change-password/change-password.component";
import { DashboardRoutingModule } from "./main/dashboard/dashboard-routing.module";
import { NgChartsModule } from "ng2-charts";
import { DefaultLayoutComponent } from "./containers";
import { ToastrModule } from "ngx-toastr";

@NgModule({
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
    P404Component,
    P500Component,
    LoginComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    IdentityRevealedValidatorDirective,
    CompareDateValidatorDirective,
    CompareReviewDateValidatorDirective,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    NgChartsModule,
    ReactiveFormsModule,
    SharePipeModule,
    DashboardRoutingModule,
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-top-right",
      timeOut: 2000,
      progressBar: true,
      closeButton: true,
      preventDuplicates: true,
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    DatePipe,
    HttpErrorHandler,
    CommonService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
